import React, { useEffect, useMemo, useState } from "react";
import { clamp, numOnly, parseTime } from "./BusinessZones.utils";

const TimeEditor = ({ label, value, onSave, isSaving }) => {
  const initial = useMemo(() => parseTime(value), [value]);
  const [hour, setHour] = useState(initial.h);
  const [minute, setMinute] = useState(initial.m);

  useEffect(() => {
    const { h, m } = parseTime(value);
    setHour(h);
    setMinute(m);
  }, [value]);

  const handleSave = () => {
    const h = clamp(hour, 0, 23);
    const m = clamp(minute, 0, 59);
    if (h === "" || m === "") return;
    onSave(`${h}:${m}`);
  };

  const invalid =
    hour === "" ||
    minute === "" ||
    Number(hour) < 0 ||
    Number(hour) > 23 ||
    Number(minute) < 0 ||
    Number(minute) > 59;
  const changed = hour !== initial.h || minute !== initial.m;

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-300">{label}</label>
      <div className="flex items-center gap-2">
        <select
          value={hour}
          onChange={(e) => setHour(numOnly(e.target.value))}
          className="custom-select h-10 rounded-md border border-gray-700 bg-gray-800 px-3 py-2 text-sm text-white focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
        >
          <option value="" disabled>
            HH
          </option>
          {Array.from({ length: 24 }).map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
        <span className="text-gray-400">:</span>
        <select
          value={minute}
          onChange={(e) => setMinute(numOnly(e.target.value))}
          className="custom-select h-10 rounded-md border border-gray-700 bg-gray-800 px-3 py-2 text-sm text-white focus:border-transparent focus:ring-2 focus:ring-blue-500 focus:outline-none"
        >
          <option value="" disabled>
            MM
          </option>
          {Array.from({ length: 60 }).map((_, i) => (
            <option key={i} value={String(i)}>
              {i}
            </option>
          ))}
        </select>
        <button
          onClick={handleSave}
          disabled={invalid || !changed || isSaving}
          className="flex items-center justify-center rounded bg-blue-600 px-3 py-2 text-sm text-white hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-50"
        >
          {isSaving ? (
            <div className="h-4 w-4 animate-spin rounded-full border-b-2 border-white"></div>
          ) : (
            "Save"
          )}
        </button>
      </div>
      {invalid && (
        <p className="text-xs text-red-500">Enter a valid time (0-23 : 0-59)</p>
      )}
    </div>
  );
};

export default TimeEditor;
